import React, { useState, useEffect, useContext } from 'react';
import api from '../api';
import { Context } from '../contexts/StateContext';


//---------------Listar Franquia--------------
export const API_Franquia = () => {
    const { state, dispatch } = useContext(Context);
    const { listaPesquisa } = state.parametros;
    const { franquia, foneCelular } = state.franquia;
    const { logado } = state.cliente;

    // -------------------------------
    async function AddFranquia() {
        await api.post('/franquia/add', {
            userCadastro: logado.idLogado? logado.idLogado : null,
            nome: franquia.nome,
            cpfCnpj: franquia.cpfCnpj,
            endereco: {
                cidade: franquia.cidade
            },
            foneCelular: {
                numeroCel: foneCelular?.numeroCel,
            },

        }).then(res => {
            if (res.data.error) {
                alert(res.data.error.msg)

            } else {
                dispatch({
                    type: 'SET_Franquia',
                    payload: {
                        ...franquia,
                        id: res.data._id,
                        nome: res.data.nome,
                        cpfCnpj: res.data.cpfCnpj,
                        cidade: res.data.endereco.cidade,
                    }
                });
                alert('Representante OK!!!');
            }
        }).catch(erro => erro)
    };

    // -----------------------
    async function PesqFranquia(nome) {
        if (nome) {
            await api.get(`/franquia/nome/${nome}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: {
                            ...listaPesquisa,
                            listaFranquia: res.data.length > 0 ? res.data : [],
                            alertaNovo: res.data.length > 0 ? false : true
                        }
                    });
                }).catch((error) => {
                    alert("Ocorreu um erro ao buscar os items");
                });
        }
    };

    // -----------------------
    async function PesqFranquiaID(id) {
        if (id) {
            await api.get(`/franquia/${id}`)
            .then(res => {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaFranquia: [res.data]
                    }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
            });
        }
    };
    
    // -----------------------
    async function PesqFranquiaCPF(cpf) {
        if (cpf) {
            await api.get(`/franquia/filtrar/${cpf}`)
            .then(res => {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaFranquia: res.data? [res.data] : [],
                    }
                });
            }).catch((error) => {
                alert("Ocorreu um erro ao buscar os items");
            });
        }
    };

    // ------------------------
    async function TodasFranquia() {
        await api.get('/franquia/tudo')
            .then(res => {
                const busca = res.data;
                const result = busca.map(s => ({ value: s._id, label: s.nome }))
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaFranquia: res.data.length > 0 ? result : [],
                    }
                });
            });
    };

    // -------------------------------
    async function AtualizarFranquia(id, dadosAtualizar) {
        try {
            const res = await api.put(`/franquia/atualizar/${id}`, dadosAtualizar);
            
            if (res.data.error) {
                alert(res.data.error.msg);
                return { success: false, error: res.data.error.msg };
            } else {
                // Atualizar o estado global com os dados atualizados
                dispatch({
                    type: 'SET_Franquia',
                    payload: {
                        ...franquia,
                        ...dadosAtualizar,
                    }
                });

                // Atualizar foneCelular se foi passado
                if (dadosAtualizar.foneCelular) {
                    dispatch({
                        type: 'set_foneFranquia',
                        payload: {
                            ...foneCelular,
                            ...dadosAtualizar.foneCelular
                        }
                    });
                }

                alert('Dados da franquia atualizados com sucesso!');
                return { success: true, data: res.data };
            }
        } catch (erro) {
            console.error('Erro ao atualizar franquia:', erro);
            alert('Erro ao atualizar dados da franquia.');
            return { success: false, error: erro.message };
        }
    };

    return { TodasFranquia, PesqFranquiaID, PesqFranquia, AddFranquia, AtualizarFranquia, PesqFranquiaCPF }
};

//---------------Listar por CPF/CNPJ--------------
export const ListaFranquiaCPF = () => {
    const { state } = useContext(Context);
    const { franquia } = state.franquia;
    const [lista, setLista] = useState([]);

    const cpfCnpj = franquia.cpfCnpj

    async function TodasFranquia() {
        if (cpfCnpj) {
            await api.get(`/franquia/filtrar/${cpfCnpj}`)
                .then(res => {
                    setLista(res.data);
                });
        };
    };
    useEffect(() => {
        TodasFranquia()
    }, [cpfCnpj])

    return lista
};
//---------------Listar Todos Colaborador por Franquia--------------
export const ColabFranquia = () => {
    const [lista, setLista] = useState([]);
    const { state, dispatch } = useContext(Context);
    const { cliente } = state.cliente;
    const { franquia } = state.franquia;
    const id_Franquia = cliente.id_Franquia;

    async function buscar() {
        if (id_Franquia) {
            await api.get(`/franquia/colaborador/${id_Franquia}`)
                .then(res => {
                    const busca = res.data;
                    const result = busca.map(s => ({ value: s._id, label: s.nome }))
                    setLista(result);

                    dispatch({
                        type: "SET_Franquia",
                        payload: { ...franquia, "listaColaborador": result }
                    })
                });
        }
    };
    //----------------------------------------------
    useEffect(() => {
        buscar()
    }, [id_Franquia])

    return lista
};

//---------------Listar Todos Servicos--------------
export const Servicos = () => {
    const [lista, setServico] = useState([]);
    const { state, dispatch } = useContext(Context);

    async function buscarServicos() {

        await api.get(`/servico/todos`)
            .then(res => {
                const busca = res.data;
                const result = busca.map(s => ({ value: s._id, label: s.titulo }))
                setServico(result);
            });

    };
    //----------------------------------------------
    useEffect(() => {
        buscarServicos()
    }, [])

    return lista
};
//---------------Listar Todos Servicos por Franquia--------------
export const ServFranquia = () => {
    const [listaServico, setServico] = useState([]);
    const { state, dispatch } = useContext(Context);
    const { colaborador } = state.colaborador;
    const { franquia } = state.franquia;
    const id_Franquia = colaborador.id_Franquia;

    async function buscarServicos() {
        if (id_Franquia) {
            await api.get(`/franquia/servico/${id_Franquia}`)
                .then(res => {
                    const busca = res.data;
                    const result = busca.map(s => ({ value: s._id, label: s.titulo }))
                    setServico(result);

                    dispatch({
                        type: "SET_Franquia",
                        payload: { ...franquia, "listaServicos": result }
                    })
                });
        }
    };
    //----------------------------------------------
    useEffect(() => {
        buscarServicos()
    }, [id_Franquia])

    return listaServico
};
//---------------------------------------------



